
@if (logginIn) {
    <div class="login-loading">
        <h1>Logging In...</h1>
        <div class="loading-content">
            <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
            <p>Connecting to Discord...</p>
        </div>
    </div>
} @else if (loginError) {
    <div class="login-error">
        <div class="error-card">
            <div class="error-header">
                <mat-icon class="error-icon">error</mat-icon>
                <h1>Login Failed</h1>
            </div>
            <div class="error-message">
                <p>{{ loginError }}</p>
            </div>
            <div class="error-actions">
                <button mat-raised-button color="primary" (click)="retryLogin()">
                    <mat-icon>refresh</mat-icon>
                    Try Again
                </button>
            </div>
            <div class="error-details">
                <button mat-button (click)="toggleErrorDetails()" class="details-toggle">
                    <mat-icon>{{ showErrorDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ showErrorDetails ? 'Hide' : 'Show' }} Details
                </button>
                @if (showErrorDetails) {
                    <div class="details-content">
                        <div class="details-section">
                            <h3>Error Information</h3>
                            <p><strong>Type:</strong> {{ loginErrorDetails?.error_type }}</p>
                            <p><strong>Time:</strong> {{ loginErrorDetails?.timestamp | date:'medium' }}</p>
                            <p><strong>Status:</strong> {{ loginErrorDetails?.status }}</p>
                        </div>
                        @if (loginErrorDetails?.debug_info) {
                            <div class="details-section">
                                <h3>Debug Information</h3>
                                <pre class="debug-info">{{ loginErrorDetails.debug_info | json }}</pre>
                            </div>
                        }
                        <div class="details-section">
                            <h3>Report This Issue</h3>
                            <p>If this problem persists, please report it to the developers with the information above.</p>
                            <button mat-stroked-button (click)="copyErrorDetails()">
                                <mat-icon>content_copy</mat-icon>
                                Copy Details
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    <div class="login-container">
        <!-- Hero Section -->
        <div class="login-hero">
            <h1>Login or Register</h1>
            <p class="hero-subtitle">
                Unlock the full potential of Jar.games using your Discord account.
            </p>
            <div class="hero-login">
                <div style="display: inline-flex; flex-direction: column; gap: 4px;">
                    <button mat-flat-button  class="hero-login-button" [disabled]="!powState" (click)="login()">
                        <mat-icon>login</mat-icon>
                        Login with Discord
                    </button>
                    @if (!powState && !powError) {
                        <app-pow-progress />
                    }
                </div>
                @if (powError) {
                    <p class="pow-status">Couldn't prepare the login. <button mat-button (click)="startChallenge()">Retry</button></p>
                } @else if (!powState) {
                    <p class="pow-status">Preparing secure login...</p>
                }
            </div>
        </div>

        <!-- Benefits Section -->
        <div class="benefits-grid">

            <mat-card class="benefit-card">
                <mat-card-header>
                    <mat-icon mat-card-avatar class="benefit-icon">star</mat-icon>
                    <mat-card-title>Patreon Supporter Perks</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>Connect your Patreon and VRChat account to unlock exclusive in-game benefits and supporter features across Jar's worlds.</p>
                    <ul>
                        <li>Access to exclusive in-game features</li>
                        <li>Special recognition and supporter roles</li>
                    </ul>
                    <p>Don't want to register to get your perks? <button mat-button routerLink="/patreon">Submit as Guest</button></p>
                </mat-card-content>
            </mat-card>

            <mat-card class="benefit-card">
                <mat-card-header>
                    <mat-icon mat-card-avatar class="benefit-icon">person</mat-icon>
                    <mat-card-title>Manage Your Account</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>Connect your accounts and manage your profile across all of Jar's projects and platforms.</p>
                    <ul>
                        <li>Link your VRChat account for seamless integration</li>
                        <li>Connect Patreon for automatic perk activation</li>
                    </ul>
                </mat-card-content>
            </mat-card>
        </div>

    </div>
}